import { NavLink, useLocation } from "react-router-dom";
import { ROUTES } from "../assets/constant";
import FilterOptions from "./filter-options";
import { useSelector } from "react-redux";

export const SideNavigaton = () => {
  const location = useLocation();
  const showFilter = location.pathname === ROUTES.SEARCH;

  const user = useSelector((state) => state.auth);
  const hasSubscription = user.subscription && user.subscription.length > 0;

  return (
    <div className={`col-md-3 col-lg-2 p-0 bg-body-tertiary sidenav-container ${!hasSubscription ? 'no-subscription' : ''}`}>
      <div className="sidenav d-flex flex-column flex-shrink-0 px-2">
        <ul className="nav nav-pills flex-column">
          <li className="nav-item">
            <NavLink
              to={ROUTES.DASHBOARD}
              activeClassName="active"
              className="nav-link"
              aria-current="page">
              <i className="fa-solid fa-cube"></i> Dashboad
            </NavLink>
          </li>
          <li>
            <NavLink
              to={ROUTES.FAVOURITE}
              activeClassName="active"
              className="nav-link">
              <i className="fa-solid fa-repeat"></i> Favourite
            </NavLink>
          </li>
          <li>
            <NavLink
              to={ROUTES.REPORTED_ISSUE}
              activeClassName="active"
              className="nav-link ">
              <i className="fa-regular fa-user"></i> Reported Issue
            </NavLink>
          </li>
          <li>
            <NavLink
              to={ROUTES.MANAGE_SUBSCRIPTION}
              activeClassName="active"
              className="nav-link ">
              <i className="fa-regular fa-paste"></i> Manage Subscription
            </NavLink>
          </li>
        </ul>
      </div>
      {showFilter && (
        <div className="sidenav d-flex flex-column flex-shrink-0">
          <FilterOptions showToggle={false} />
        </div>
      )}

    </div>
  );
};
